import { render, staticRenderFns } from "./Imagenes.vue?vue&type=template&id=c27f0d70&"
import script from "./Imagenes.vue?vue&type=script&lang=js&"
export * from "./Imagenes.vue?vue&type=script&lang=js&"
import style0 from "./Imagenes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports